import React, { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MultipleLocationsModal from "./MultipleLocationsModal";
import { formatRackLocationLabel } from "src/utils/rackLocations";

export default function LocationSelectorModal({ onClose, onSelectLocation, asset }) {
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [showLocationSelector, setShowLocationSelector] = useState(false);

  const handleConfirm = () => {
    onSelectLocation(selectedLocation);
  };

  if (!showLocationSelector) {
    return (
      <MultipleLocationsModal
        onClose={onClose}
        onSelectLocation={() => setShowLocationSelector(true)}
      />
    );
  }

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Typography fontSize={24} fontWeight={500} color="textPrimary" align="center">
          Select Location
        </Typography>
        <IconButton onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 4 }}>
          {asset?.rackLocations?.map((locationData, index) => (
            <Button
              key={index}
              fullWidth
              onClick={() => setSelectedLocation(index)}
              variant={selectedLocation === index ? "contained" : "outlined"}
              sx={{ mb: 1.5, p: 1.5, fontSize: 18, fontWeight: 400 }}
            >
              {formatRackLocationLabel(locationData)}, Quantity: {locationData.sub_qty}
            </Button>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2, pb: 3, justifyContent: "center" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleConfirm}
          disabled={selectedLocation === null}
        >
          Select Location
        </Button>
      </DialogActions>
    </Dialog>
  );
}
